import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class TestimonialsSliders {
	
	constructor(el) {

		this.el = el;

		this.initTestimonialsSlidersSwipers(el);

	} 

	initTestimonialsSlidersSwipers(elm){		

		const swiper = new Swiper( elm.querySelector('.swiper'), {    
			modules           			: [ Navigation ],
			slidesPerView     			: 1,
			centeredSlides	  			: true,			
			loop              			: false,			
			spaceBetween      			: 48,
			autoHeight        			: false,
			initialSlide				: 1,
			navigation        			: {
			  	nextEl      : elm.querySelector('.swiper-button-next'),
			  	prevEl      : elm.querySelector('.swiper-button-prev'),
			}, 
			centerInsufficientSlides 	: true,
			breakpoints       			: {  
			  	10 : { 
					slidesPerView   : 1,
					spaceBetween    : 20,
					autoHeight		: true,
			  	}, 
			  	320 : { 
					slidesPerView   : 1,
					spaceBetween    : 20,
					autoHeight		: true,
			  	},     
			  	480 : { 
					slidesPerView   : 1,
					spaceBetween    : 16,
			  	},     
			  	640 : { 
					slidesPerView   : 1,
					spaceBetween    : 24,
			  	},     
			  	768 : { 
					slidesPerView   : 1,
					spaceBetween    : 32,
			  	},     
			  	1024 : { 
					slidesPerView   : 1,
					spaceBetween    : 48,
			  	},    
			  	1240 : {
					slidesPerView   : 1,
					spaceBetween    : 48,
			  	},          
			},
		});

	}

}